<template>
  <f7-fab position="center-bottom" color="black" @click="$emit('click')">
    <f7-icon ios="f7:plus" md="material:add"></f7-icon>
  </f7-fab>
</template>

<script>

  export default {
    components: {},

    // DEF-44-01: without this declaration the caller's `@click` is a fallthrough attribute
    // bound onto <f7-fab> as well, and one tap invoked the handler TWICE.
    emits: ['click'],

    props: [],

    mixins: [],

    data: function () {
      return {
        //
      };
    },

    computed: {
      //
    },

    created() {
      //
    },

    mounted() {
      //
    },

    methods: {
      //
    },

    watch: {
      //
    }
  };
</script>
